import dompurify from 'dompurify';
// use when rendering or capturing user input without React
// use with React when using the 'dangerouslySetInnerHTML' attribute

const sanitize = (valueDirty) => (
  // can customize sanitizing here as needed
  dompurify.sanitize(valueDirty)
);

export default sanitize;
